import ClientAgent from '../clientAgent'
import ProjectDetailsPermission from './Response/ProjectDetailsPermission'

export default class CloudPermissionRequests {
  /**
   * @type {Array<ProjectDetailsPermission> | null}
   * @private
   */
  _permissionRequests = []
  _ca = null

  async loadAllPermissionRequests () {
    /**
     * @type {GetAllPermissionRequestsResponse}
     */
    let response = await this.ca.makeRequest(
      'openStack/servisne/getPermissisonRequestsForAllProjectsForHorizontUser',
      {}
    )
    this._permissionRequests = []
    response.requests.forEach((request) => {
      this._permissionRequests.push(new ProjectDetailsPermission(request))
    })
  }

  /**
   * @returns {ClientAgent}
   */
  get ca () {
    if (this._ca === null) {
      this._ca = new ClientAgent()
    }
    return this._ca
  }

  set ca (value) {
    this._ca = value
  }


  get permissionRequests () {
    return this._permissionRequests
  }

  set permissionRequests (value) {
    this._permissionRequests = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/T2Cloud/CloudPermissionRequests.js